module.exports = __webpack_public_path__ + "img/storage2.8fce0880.png";